export const STAGE = {
  aspect: 9 / 16,
} as const;

export interface PointerSample {
  tMs: number;
  x: number;
  y: number;
  type?: 'down' | 'move' | 'up';
}

export interface ClickPoint {
  tMs: number;
  x: number;
  y: number;
}

export interface PathSegment {
  startMs: number;
  endMs: number;
  points: { x: number; y: number; tMs: number }[];
}

export interface BpmSegment {
  tStartMs: number;
  tEndMs: number;
  bpm: number;
  offsetMs: number;
  confidence: number;
}

export interface ChartData {
  name: string;
  density: number;
  smoothing: number;
  minSpacingPx: number;
  clickPoints: ClickPoint[];
  paths: PathSegment[];
}

export interface BeatstageBundleV1 {
  version: number;
  mode: string;
  meta: Record<string, unknown>;
  timing: {
    gridMs: number[];
    segments: BpmSegment[];
  };
  chart?: ChartData;
  supportsMods: Record<string, boolean>;
  generator?: string;
  stats?: Record<string, unknown>;
  hitObjects?: unknown[];
  audio?: { data?: string; offset?: number };
  video?: { data?: string };
}
